import axios, { AxiosError } from 'axios';
import { keepPreviousData, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { IHousingObjectResponse } from '@/types';
import { GET_NEWEST_PROJECTS_API_ENDPOINT } from '@/constants';

interface NewestProjectsParams {
  itemsLimit?: number;
  itemsPerProject?: number;
}

export const useGetNewestProjects = (
  params?: NewestProjectsParams,
  options?: Partial<UseQueryOptions<IHousingObjectResponse[], AxiosError>>,
) => {
  return useQuery<IHousingObjectResponse[], AxiosError>({
    queryKey: options?.queryKey ?? ['newest-projects', params],
    queryFn: () => axios.get(GET_NEWEST_PROJECTS_API_ENDPOINT, { params }).then((res) => res.data),
    placeholderData: keepPreviousData,
    ...options,
  });
};
